import type { ComponentProps } from "react";

export default function VisaIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="38"
      height="12"
      viewBox="0 0 38 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.6086 0.0146484C21.9853 0.0146484 19.641 1.37436 19.641 3.88652C19.641 6.76748 23.7987 6.96645 23.7987 8.41377C23.7987 9.02318 23.1003 9.56871 21.9075 9.56871C20.2147 9.56871 18.9495 8.80646 18.9495 8.80646L18.4081 11.3415C18.4081 11.3415 19.8656 11.9854 21.8007 11.9854C24.6688 11.9854 26.9256 10.5589 26.9256 8.00382C26.9256 4.95954 22.7506 4.76646 22.7506 3.42313C22.7506 2.94568 23.3239 2.42264 24.5133 2.42264C25.8553 2.42264 26.9502 2.97701 26.9502 2.97701L27.48 0.528598C27.48 0.528598 26.2887 0.0146484 24.6086 0.0146484ZM0.60797 0.199451L0.544434 0.569021C0.544434 0.569021 1.64807 0.770984 2.64206 1.17391C3.92189 1.6359 4.01309 1.90488 4.22862 2.74024L6.5774 11.7948H9.72604L14.5767 0.199451H11.4353L8.31848 8.08318L7.04664 1.40054C6.92999 0.635737 6.33916 0.199451 5.61596 0.199451H0.60797ZM15.8399 0.199451L13.3756 11.7948H16.3711L18.8268 0.199414H15.8399V0.199451ZM32.5472 0.199451C31.8249 0.199451 31.4422 0.586181 31.1613 1.26197L26.7726 11.7948H29.914L30.5218 10.0393H34.3489L34.7185 11.7948H37.4902L35.0721 0.199451H32.5472ZM32.9557 3.33215L33.8869 7.68329H31.3923L32.9557 3.33215Z"
        fill="currentColor"
      />
    </svg>
  );
}
